import type { PropsWithChildren } from 'react'
import { useIntl } from 'react-intl'
import Label from 'LuxKit/Label/Label'
import { formatInclusionsTitleBundle } from 'constants/inclusions'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import LabeledSheet from 'LuxKit/LabeledSheet'
import styled from 'styled-components'
import { rem } from 'polished'

const ContentWrapper = styled.div`
  padding: ${rem(16)};
`

interface Props {
  duration?: number
}

function BundleInclusionsLabeledContainer(props: PropsWithChildren<Props>) {
  const { duration, children } = props
  const intl = useIntl()

  const durationLabel = duration
    ? intl.formatMessage(
        {
          id: 'jkFTr5M7ZTsIPJmoWvqs',
          defaultMessage: '{title} for {duration, plural, one {a # night stay} other {# night stays}}',
          description: 'Label for exclusive/bundle inclusions with minimum stay duration',
        },
        { title: formatInclusionsTitleBundle(intl), duration },
      )
    : formatInclusionsTitleBundle(intl)

  return <LabeledSheet
    kind="exclusive"
    data-testid="bundle-inclusions-labeled-container"
    label={<>
      <CSSBreakpoint not="tablet">
        <Label kind="primary" variant="exclusive" format="propercase">{durationLabel}</Label>
      </CSSBreakpoint>
      <CSSBreakpoint only="tablet">
        <Label kind="primary" variant="exclusive" format="propercase">{formatInclusionsTitleBundle(intl)}</Label>
      </CSSBreakpoint>
    </>}
  >
    <ContentWrapper>
      {children}
    </ContentWrapper>
  </LabeledSheet>
}

export default BundleInclusionsLabeledContainer
